export const getStoreKey = ({ id }) => `store-${id}`;

export const storesKeyMatch = (storeX, storeY) =>
  storeX && storeY && getStoreKey(storeX) === getStoreKey(storeY);
